import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=4d5e04e3&"
import script from "./NextButton.vue?vue&type=script&lang=js&"
export * from "./NextButton.vue?vue&type=script&lang=js&"
import style0 from "./NextButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports